export type VideoCardData = {
  category: string;
  date: string;
  title: string;
  duration: string;
  img: string;
  subscriberOnly?: boolean;
};

export type PlaylistItemData = {
  category: string;
  date: string;
  title: string;
  duration?: string;
  img: string;
  nowPlaying?: boolean;
  subscriberOnly?: boolean;
};

export const heroVideo = {
  breadcrumb: ["財經", "論盡熱話"],
  title: "滙豐劉紹文：2026炒股不炒市 推升恒指2大關鍵",
  dateTime: "2026年1月13日 13:00",
  currentTime: "00:34",
  totalTime: "11:06",
  body: [
    "恒指去年升近28%，創8年最佳表現，滙豐金融服務亞洲投資策略主管劉紹文說，今年港股能否再下一城，要視乎企業盈利與資金流。又預期港股炒股不炒市情況會更明顯，坦言新經濟股基本面不易掌握，且相較投資美股難度為高。",
  ],
  fullArticleLinkText:
    "劉紹文：今年炒股不炒市加劇 港基本面欠亮麗 估值與市場期望俱高",
  tags: ["美股", "蘋果", "科技股"],
};

export const playlist: PlaylistItemData[] = [
  {
    category: "財經",
    date: "2026年1月13日",
    title: "滙豐劉紹文：2026炒股不炒市 推升恒指2大關鍵",
    img: "/images/video-home/playlist-thumb.png",
    nowPlaying: true,
  },
  {
    category: "財經",
    date: "2026年1月13日",
    title: "李聲揚﹕換債吊命 新世界債路漫長",
    duration: "08:24",
    img: "/images/video-home/playlist-thumb.png",
  },
  {
    category: "財經",
    date: "2026年1月8日",
    title: "滙豐私有化恒生 背後3大盤算",
    duration: "08:24",
    img: "/images/video-home/playlist-thumb.png",
    subscriberOnly: true,
  },
  {
    category: "財經",
    date: "2026年1月8日",
    title: "滙豐私有化恒生 背後3大盤算",
    duration: "08:24",
    img: "/images/video-home/playlist-thumb.png",
  },
];

export const financeVideos: VideoCardData[] = [
  {
    category: "市場信析",
    date: "12分鐘前",
    title: "林少陽：金非避險資產 買金不如買金礦股",
    duration: "08:24",
    img: "/images/video-home/finance-1.png",
  },
  {
    category: "市場信析",
    date: "1天前",
    title: "譚新強﹕中國消費力弱 谷內需談何容易？！",
    duration: "08:24",
    img: "/images/video-home/finance-2.png",
  },
  {
    category: "論盡熱話",
    date: "3天前",
    title: "看清三大趨勢 2026宜攻不宜守｜信報龍稱專欄",
    duration: "08:24",
    img: "/images/video-home/finance-3.png",
    subscriberOnly: true,
  },
  {
    category: "市場信析",
    date: "12分鐘前",
    title: "林少陽：金非避險資產 買金不如買金礦股",
    duration: "08:24",
    img: "/images/video-home/finance-1.png",
  },
];

export const peopleVideos: VideoCardData[] = [
  {
    category: "老總平常談",
    date: "12分鐘前",
    title: "龐建貽傳授藏酒秘訣﹕最貴唔一定最好！",
    duration: "08:24",
    img: "/images/video-home/people-1.png",
  },
  {
    category: "老總平常談",
    date: "1天前",
    title: "許正宇：全球「堡壘化」加強金融基建 打造黃金中心",
    duration: "08:24",
    img: "/images/video-home/people-2.png",
  },
  {
    category: "老總平常談",
    date: "3天前",
    title: "陳家亮談生死：生人更值得超渡",
    duration: "08:24",
    img: "/images/video-home/people-3.png",
  },
  {
    category: "老總平常談",
    date: "12分鐘前",
    title: "龐建貽傳授藏酒秘訣﹕最貴唔一定最好！",
    duration: "08:24",
    img: "/images/video-home/people-1.png",
  },
];

export const topicVideos: VideoCardData[] = [
  {
    category: "論盡熱話",
    date: "12分鐘前",
    title: "梁兆基﹕香港屬城市經濟 不應搞太多產業",
    duration: "08:24",
    img: "/images/video-home/topic-1.png",
    subscriberOnly: true,
  },
  {
    category: "啟發新知",
    date: "1天前",
    title: "冰島蚊蹤 日本熊襲 全球暖化警號",
    duration: "08:24",
    img: "/images/video-home/topic-2.png",
    subscriberOnly: true,
  },
  {
    category: "特朗普2.0",
    date: "3天前",
    title: "「經貿牌」不是最強 警惕特朗普打響「軍事牌」｜信報李道專欄",
    duration: "08:24",
    img: "/images/video-home/topic-3.png",
  },
  {
    category: "論盡熱話",
    date: "12分鐘前",
    title: "梁兆基﹕香港屬城市經濟 不應搞太多產業",
    duration: "08:24",
    img: "/images/video-home/topic-1.png",
    subscriberOnly: true,
  },
];
